import { Box, Typography } from "@mui/material";
// svg
import { ReactComponent as IconDrag } from "../../../assets/svg/drag.svg";

export const AreaItem = ({ area, disabled }) => {
  // Handle drag start event
  const handleDragStart = (e, area) => {
    e.dataTransfer.setData("application/reactflow", JSON.stringify(area));
    e.dataTransfer.effectAllowed = "move";
  };
  return (
    <>
      <Box
        sx={{
          width: "100%",
          height: "48px",
          minHeight: "48px",
          display: "flex",
          alignItems: "center",
          gap: "16px",
          pr: "16px",
          borderRadius: "8px",
          background: disabled ? '#EEEEF6' : "#fff",
          boxShadow: disabled ? 0 : 3,
          overflow: "hidden",
          cursor: disabled ? 'not-allowed' : "grab",
          opacity: disabled ? 0.5 : 1,
        }}
        onDragStart={(e) => handleDragStart(e, area)}
        draggable={!disabled}
      >
        <Box
          sx={{
            width: "48px",
            minWidth: "48px",
            height: "100%",
            background: area.color,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <IconDrag fill="#fff" />
        </Box>
        <Typography>{area.display_name ? area.display_name : ""}</Typography>
      </Box>
    </>
  );
};
